module.exports = __webpack_public_path__ + "img/seller-mall.3d9cdbc6.png";